export const EE_BASE_URL = 'https://www.sportsinfocus.com'
export const API_BASE_URL 	= `${EE_BASE_URL}/api/1.0/`